export function usePrefixCls(val: string) {
  return "howuse-" + val
}